/*企业简介*/
export default {
  path: '/intros',
  component: resolve => require(['@/views/intros'], resolve),
  children: [
    {
      path: '1',
      component: resolve => require(['@/views/intros/intro_1.vue'], resolve)
    },
    {
      path: '2',
      component: resolve => require(['@/views/intros/intro_2.vue'], resolve)
    },
    {
      path: '3',
      component: resolve => require(['@/views/intros/intro_3.vue'], resolve)
    },
    {
      path: '4',
      component: resolve => require(['@/views/intros/intro_4.vue'], resolve)
    },
    {
      path: '5',
      component: resolve => require(['@/views/intros/intro_5.vue'], resolve)
    },
    {
      path: '6',
      component: resolve => require(['@/views/intros/intro_6.vue'], resolve)
    },
    {
      path: '7',
      component: resolve => require(['@/views/intros/intro_7.vue'], resolve)
    },
    {
      path: 'mob_list',
      component: resolve => require(['@/components/details_figure_mobile/intros'], resolve)
    },
    {
      path: 'mob_1',
      component: resolve => require(['@/views/intros_mob/intro_1.vue'], resolve)
    },
    {
      path: 'mob_2',
      component: resolve => require(['@/views/intros_mob/intro_2.vue'], resolve)
    },
    {
      path: 'mob_3',
      component: resolve => require(['@/views/intros_mob/intro_3.vue'], resolve)
    },
    {
      path: 'mob_4',
      component: resolve => require(['@/views/intros_mob/intro_4.vue'], resolve)
    },
    {
      path: 'mob_5',
      component: resolve => require(['@/views/intros_mob/intro_5.vue'], resolve)
    },
    {
      path: 'mob_6',
      component: resolve => require(['@/views/intros_mob/intro_6.vue'], resolve)
    },
    {
      path: 'mob_7',
      component: resolve => require(['@/views/intros_mob/intro_7.vue'], resolve)
    }
  ]
}
